const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.ApplicationFeatureFlagServiceSimpleClient =
  function ApplicationFeatureFlagServiceSimpleClient(
    hostname,
    credentials,
    options
  ) {
    if (!options) options = {};
    options["format"] = "text";

    this.client_ = new grpc.web.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;

    this.pullApplicationFeatureFlags =
      this.pullApplicationFeatureFlags.bind(this);
  };
const methodInfo_ApplicationFeatureFlagService_PullApplicationFeatureFlags =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.ApplicationFeatureFlagService/PullApplicationFeatureFlags",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest,
    imports.stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullApplicationFeatureFlagsResponse.decode
  );
module.exports.ApplicationFeatureFlagServiceSimpleClient.prototype.pullApplicationFeatureFlags =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullApplicationFeatureFlagsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.ApplicationFeatureFlagService/PullApplicationFeatureFlags",
      message,
      metadata || {},
      methodInfo_ApplicationFeatureFlagService_PullApplicationFeatureFlags
    );
  };
